
import { useState } from 'react';

export default function TeaSubscribeForm() {
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    interest: '緑茶',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!formData.email || !formData.name) {
      setError('お名前とメールアドレスは必須です');
      return;
    }

    setIsSubmitting(true);

    try {
      const body = new URLSearchParams();
      body.append('email', formData.email);
      body.append('name', formData.name);
      body.append('interest', formData.interest);

      const res = await fetch('https://readdy.ai/api/form/d69si15bd17lru29lf20', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      if (res.ok) {
        setIsSubmitted(true);
      } else {
        setError('送信に失敗しました。もう一度お試しください。');
      }
    } catch {
      setError('送信に失敗しました。もう一度お試しください。');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 sm:py-24 md:py-32 bg-[#FAF8F5]" aria-labelledby="tea-subscribe-heading">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-10 sm:mb-12">
          <span className="inline-block px-3 py-1.5 bg-[#7B8C3E]/10 text-[#7B8C3E] text-xs tracking-[0.15em] rounded-full mb-4 sm:mb-6">
            NEWSLETTER
          </span>
          <h2 id="tea-subscribe-heading" className="text-2xl sm:text-3xl md:text-4xl font-extralight text-black mb-3 sm:mb-4 tracking-[0.1em]">
            最新情報をお届け
          </h2>
          <p className="text-sm sm:text-base text-black/60 font-extralight tracking-wide">
            新しい茶葉の入荷やキャンペーン情報をいち早くお届けします
          </p>
        </div>

        {isSubmitted ? (
          <div className="bg-white rounded-2xl p-8 sm:p-10 text-center shadow-sm">
            <div className="w-16 h-16 flex items-center justify-center bg-[#7B8C3E]/10 rounded-full mx-auto mb-4">
              <i className="ri-check-line text-3xl text-[#7B8C3E]" aria-hidden="true"></i>
            </div>
            <h3 className="text-xl font-light text-black mb-2">ご登録ありがとうございます</h3>
            <p className="text-sm text-black/60 font-extralight">
              最新のお茶情報をお届けいたします。お楽しみに！
            </p>
          </div>
        ) : (
          <form
            id="tea-subscription-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="bg-white rounded-2xl p-6 sm:p-8 md:p-10 shadow-sm"
          >
            <div className="space-y-4 sm:space-y-5">
              <div>
                <label htmlFor="tea-name" className="block text-sm font-light text-black mb-2 tracking-wide">
                  お名前 <span className="text-[#C4787A]">*</span>
                </label>
                <input
                  id="tea-name"
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="山田 太郎"
                  className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-light text-black placeholder:text-black/30 focus:outline-none focus:ring-2 focus:ring-[#7B8C3E]/30 focus:border-[#7B8C3E] transition-colors"
                  required
                />
              </div>

              <div>
                <label htmlFor="tea-email" className="block text-sm font-light text-black mb-2 tracking-wide">
                  メールアドレス <span className="text-[#C4787A]">*</span>
                </label>
                <input
                  id="tea-email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="example@email.com"
                  className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-light text-black placeholder:text-black/30 focus:outline-none focus:ring-2 focus:ring-[#7B8C3E]/30 focus:border-[#7B8C3E] transition-colors"
                  required
                />
              </div>

              <div>
                <label htmlFor="tea-interest" className="block text-sm font-light text-black mb-2 tracking-wide">
                  興味のあるお茶
                </label>
                <select
                  id="tea-interest"
                  name="interest"
                  value={formData.interest}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-light text-black focus:outline-none focus:ring-2 focus:ring-[#7B8C3E]/30 focus:border-[#7B8C3E] transition-colors cursor-pointer"
                >
                  <option value="緑茶">緑茶</option>
                  <option value="ほうじ茶">ほうじ茶</option>
                  <option value="和紅茶">和紅茶</option>
                  <option value="烏龍茶">烏龍茶</option>
                  <option value="すべて">すべてに興味がある</option>
                </select>
              </div>

              {error && (
                <p className="text-sm text-[#C4787A] font-light" role="alert">{error}</p>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-3 sm:py-4 bg-[#7B8C3E] text-white text-sm font-light tracking-[0.1em] hover:bg-[#6A7A35] transition-colors whitespace-nowrap rounded-lg cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? '送信中...' : '登録する'}
              </button>
            </div>
          </form>
        )}
      </div>
    </section>
  );
}
